import { useCallback, useState } from 'react';
import { ConstantFunctions } from '../constant-functions';

interface OpenState {
  isOpen: boolean;
  onOpen: () => void;
  onClose: () => void;
}

interface Position {
  x: number;
  y: number;
}

interface MenuState {
  isOpen: boolean;
  position: Position;
  onOpen: (e: React.MouseEvent, right?: boolean) => void;
  onClose: () => void;
}

export function useOpenMenu(): OpenState {
  const [isOpen, setOpen] = useState(false);
  const onClose = useCallback(() => setOpen(false), []);
  const onOpen = useCallback(() => {
    setOpen(true);
  }, []);
  return {
    isOpen,
    onOpen,
    onClose,
  };
}

export function useOpenMenuWithPosition(offsetX?: number, offsetY?: number): MenuState {
  const { isOpen, onClose, onOpen: openMenu } = useOpenMenu();
  const [position, setPosition] = useState<Position>({ x: 0, y: 0 });
  const onOpen = useCallback((e: React.MouseEvent, right?: boolean) => {
    ConstantFunctions.stopEvent(e);
    const buttonRect = e.currentTarget.getBoundingClientRect();
    const correctionX = offsetX ? offsetX : 0;
    const correctionY = offsetY ? offsetY : 0;
    const x = right ? buttonRect.left + buttonRect.width + correctionX : buttonRect.left + correctionX;
    const y = buttonRect.bottom + 10 + correctionY;
    setPosition({ x, y });
    openMenu();
  }, []);
  return {
    isOpen,
    position,
    onOpen,
    onClose,
  };
}


